import { Link } from "react-router";
import logoImage from "figma:asset/ddb57671df87312087712466a3a43b048ecff0a3.png";
import { JOIN_FORM_URL } from "../config/links";

const exploreLinks = [
  { label: "About", to: "/about" },
  { label: "Labs", to: "/labs" },
  { label: "Blog", to: "/blog" },
];

const externalLinks = [
  { label: "GitHub", href: "https://github.com/unpatterned-labs" },
  { label: "Substack", href: "https://theunpatterned.substack.com" },
  { label: "LinkedIn", href: "https://linkedin.com/company/unpatterned-ai" },
  { label: "Instagram", href: "https://instagram.com/theunpatterned" },
];

export default function Footer() {
  return (
    <footer className="border-t border-[#050e1d]/10 bg-white px-6">
      <div className="mx-auto max-w-6xl">
        <div className="grid gap-12 py-16 md:grid-cols-12 md:py-20">
          <div className="md:col-span-6">
            <Link to="/" className="inline-flex">
              <img src={logoImage} alt="Unpatterned" className="h-9" />
            </Link>
            <p className="mt-7 max-w-lg font-['DM_Serif_Display',serif] text-3xl leading-tight text-[#050e1d] md:text-4xl">
              Open systems for data, identity, and intelligence.
            </p>
            <a
              href="mailto:connect@unpatterned.org"
              className="mt-7 inline-block font-['Manrope',sans-serif] text-sm font-semibold text-[#184b9d] transition-colors hover:text-[#050e1d]"
            >
              connect@unpatterned.org
            </a>
          </div>

          <nav
            aria-label="Footer"
            className="grid grid-cols-2 gap-8 md:col-span-5 md:col-start-8"
          >
            <div>
              <h2 className="font-['Manrope',sans-serif] text-xs font-semibold uppercase tracking-[0.16em] text-[#050e1d]/40">
                Explore
              </h2>
              <ul className="mt-5 space-y-3">
                {exploreLinks.map((link) => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      className="font-['Manrope',sans-serif] text-sm font-medium text-[#050e1d]/70 transition-colors hover:text-[#184b9d]"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
                <li>
                  <a
                    href={JOIN_FORM_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="font-['Manrope',sans-serif] text-sm font-medium text-[#050e1d]/70 transition-colors hover:text-[#184b9d]"
                  >
                    Join
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h2 className="font-['Manrope',sans-serif] text-xs font-semibold uppercase tracking-[0.16em] text-[#050e1d]/40">
                Follow
              </h2>
              <ul className="mt-5 space-y-3">
                {externalLinks.map((link) => (
                  <li key={link.href}>
                    <a
                      href={link.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="font-['Manrope',sans-serif] text-sm font-medium text-[#050e1d]/70 transition-colors hover:text-[#184b9d]"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </nav>
        </div>

        <div className="flex flex-col gap-2 border-t border-[#050e1d]/10 py-6 font-['Manrope',sans-serif] text-xs text-[#050e1d]/45 sm:flex-row sm:items-center sm:justify-between">
          <span>© {new Date().getFullYear()} Unpatterned</span>
          <span>Research, infrastructure, and knowledge network.</span>
        </div>
      </div>
    </footer>
  );
}
